import { NavLink } from 'react-router-dom';

import { AllocabLogo } from './AllocabLogo';
import { useAccount } from '../../contexts/AccountContext';
import type { ModuleKey } from '../../types/extranet-api.types';

interface NavItem {
  to: string;
  label: string;
  module: ModuleKey;
  end?: boolean;
}

const NAV_ITEMS: NavItem[] = [
  { to: '/', label: 'Tableau de bord', module: 'dashboard', end: true },
  { to: '/incidents', label: 'Incidents', module: 'incidents' },
  { to: '/performance', label: 'Performance', module: 'performance' },
  { to: '/invoices', label: 'Facturation', module: 'invoices' },
  { to: '/lost-found', label: 'Objets trouvés', module: 'lostFound' },
  { to: '/admin', label: 'Administration', module: 'admin' },
];

export const Sidebar = () => {
  const { config, can } = useAccount();
  const visibleItems = NAV_ITEMS.filter(item => can(item.module, 'read'));

  return (
    <aside className="w-[240px] shrink-0 border-r border-extranet-border bg-extranet-card flex flex-col">
      <div className="px-6 py-5 border-b border-extranet-border">
        <div className="flex items-baseline gap-2">
          <AllocabLogo className="h-5 w-auto text-extranet-text-primary" />
          <span className="font-mono text-[11px] uppercase tracking-wide text-extranet-text-tertiary">Extranet</span>
        </div>
        <p className="text-xs text-extranet-text-tertiary mt-1.5">{config.name}</p>
      </div>

      <nav className="flex-1 px-3 py-4 flex flex-col gap-0.5">
        {visibleItems.map(item => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              [
                'px-3 py-2 rounded-md text-sm transition-colors duration-100',
                isActive
                  ? 'bg-extranet-card-muted text-extranet-text-primary font-medium'
                  : 'text-extranet-text-secondary hover:bg-extranet-card-muted hover:text-extranet-text-primary',
              ].join(' ')
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="px-6 py-4 border-t border-extranet-border">
        <p className="text-extranet-text-tertiary text-xs">v0.1.0</p>
      </div>
    </aside>
  );
};
